export default {
  app: {
    state: {
      notifications: [],
      service_data: localStorage.getItem('service_data') || JSON.stringify({
        login: '',
        password: '',
        deviceName: ''
      }),
      scan_config: localStorage.getItem('scan_config') || JSON.stringify({
        antiSpoofing: false,
        opencv: true,
        challenge: false,
        recognitionThreshold: 0.75,
        livenessThreshold: 0.99,
        minDetectionConfidence: 0.5,
        maxFps: 5,
        useGpu: false,
      })
    },
    mutations: {
      setServiceData(state, value) {
        localStorage.setItem('service_data', JSON.stringify(value))
        state.service_data = value
      },
      setScanConfig(state, value) {
        localStorage.setItem('scan_config', JSON.stringify(value))
        state.scan_config = value
      },
      setNotifications(state, value) {
        state.notifications = value
      },
    },
    getters: {
      getServiceData(state) {
        const data = localStorage.getItem('service_data')?.length > 0 ?  localStorage.getItem('service_data'): state.service_data
        return JSON?.parse(data)
      },
      getScanConfig(state) {
        const data = localStorage.getItem('scan_config')?.length > 0 ? localStorage.getItem('scan_config') : state.scan_config
        return JSON?.parse(data)
      },
      getNotifications(state) {
        return state.notifications
      },
    },
    actions: {
      updateServiceData({ commit, }, value) {
        commit('setServiceData', value)
      },
      updateScanConfig({ commit, }, value) {
        commit('setScanConfig', value)
      },
      updateNotifications({ commit, }, value) {
        commit('setNotifications', value)
      },
    },
    namespaced: true,
  },
}
